import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { LocaleString } from '@/api-client/models/utilization/Contracts'
import CardChart from './CardChart.vue'
import { Chart as ChartDefinition } from './ChartComponent'
import { useI18n } from 'vue-i18n'
import { computed, inject } from 'vue'
import { sharedDataKey } from '../../types'

export type Chart = {
  name: string
  title: LocaleString
  info?: LocaleString
  props: ChartDefinition
}

type Props = {
  charts: Chart[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ChartList',
  props: {
    charts: {}
  },
  setup(__props: any) {



const { locale } = useI18n()

const sharedData = inject(sharedDataKey)

const fullscreen = computed(() => sharedData?.fullscreen ?? false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.charts, (chart) => {
    return (_openBlock(), _createBlock(CardChart, {
      key: chart.title[_unref(locale)] + chart.name,
      title: chart.title[_unref(locale)],
      info: chart.info?.[_unref(locale)],
      chart: chart.props,
      dashboardFullscreen: fullscreen.value,
      "enable-fullscreen": true
    }, null, 8, ["title", "info", "chart", "dashboardFullscreen"]))
  }), 128))
}
}

})